import { create } from 'zustand';
import type { AuthUser } from '../../../api/endpoints/auth';
import { authApi } from '../../../api/endpoints/auth';
import { setAccessToken, setForcedLogoutHandler } from '../../../api/client';

interface AuthState {
  user: AuthUser | null;
  isBootstrapping: boolean;
  bootstrap: () => Promise<void>;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  setUser: (user: AuthUser | null) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isBootstrapping: true,

  bootstrap: async () => {
    try {
      // Intenta refrescar usando la cookie httpOnly (si está)
      const { accessToken, user } = await authApi.refresh();
      setAccessToken(accessToken);
      set({ user, isBootstrapping: false });
    } catch {
      setAccessToken(null);
      set({ user: null, isBootstrapping: false });
    }
  },

  login: async (email, password) => {
    const { accessToken, user } = await authApi.login(email, password);
    setAccessToken(accessToken);
    set({ user });
  },

  logout: async () => {
    try {
      await authApi.logout();
    } catch {
      // ignoramos: el cliente queda sin sesión de todas formas
    }
    setAccessToken(null);
    set({ user: null });
  },

  setUser: (user) => set({ user }),
}));

// Cuando el cliente axios detecta un 401 irrecuperable, limpiamos sesión.
setForcedLogoutHandler(() => {
  useAuthStore.getState().setUser(null);
  setAccessToken(null);
});
